import { Api, ApiMethod } from "../components/common/ApiLinkedButton";
import { apiLinkConstants } from "../constants";
import { LinkHelpers } from "../helpers/Link.Helpers";
import { SearchRequest } from "../model/search/UserSearchRequestV1";
import { PageResponse } from "../paging/Paging.Model";
import { QuestionConstants } from "./Question.Constants";
import {
  Question,
  QuestionCreateUpdateRequest,
  QuestionSearchResponse,
} from "./Question.Model";
import { AnswerSubmission } from "./QuestionAnswerSubmission.model";

export class QuestionsAPI {
  public static fetchQuestionDetails(questionId: number): Api<void, Question> {
    let api = apiLinkConstants.QUESTIONS_FETCH_SINGLE_BY_ID.replace(
      "{questionId}",
      questionId + ""
    );
    return new Api<void, Question>(api, ApiMethod.GET);
  }

  public static search(): Api<SearchRequest, PageResponse<Question>> {
    return new Api<SearchRequest, PageResponse<Question>>(
      apiLinkConstants.QUESTIONS_SEARCH,
      ApiMethod.POST
    );
  }

  public static async getAllQuestions(): Promise<QuestionSearchResponse> {
    return this.search()
      .executeV2({
        searchTokens: [],
        pageParams: { size: 10000, page: 0 },
      })
      .then((response: PageResponse<Question>) => {
        return { questions: response.content };
      });
  }

  public static addQuestion(
    question: QuestionCreateUpdateRequest
  ): Api<QuestionCreateUpdateRequest, Question> {
    return new Api<QuestionCreateUpdateRequest, Question>(
      apiLinkConstants.QUESTIONS_ADD,
      ApiMethod.POST
    );
  }

  public static updateQuestion(
    question: QuestionCreateUpdateRequest
  ): Api<QuestionCreateUpdateRequest, Question> {
    let api = apiLinkConstants.QUESTIONS_UPDATE_SINGLE_BY_ID.replace(
      "{questionId}",
      question.id + ""
    );
    return new Api<QuestionCreateUpdateRequest, Question>(api, ApiMethod.PUT);
  }

  public static submitAnswer(
    questionId: string,
    userId: string,
    inputValue: AnswerSubmission
  ): Api<AnswerSubmission, AnswerSubmission> {
    return new Api<AnswerSubmission, AnswerSubmission>(
      QuestionConstants.QUESTION_ANSWER_SUBMISSION_ADD.replaceAll(
        "{questionId}",
        questionId
      ).replaceAll("{userId}", userId),
      ApiMethod.POST
    );
  }

  public static mergeQuestion(
    questionIdToMergeInto: number,
    questionIdToBeMerged: number
  ): Api<void, void> {
    let apiUrl = QuestionConstants.API_QUESTIONS_MERGE.replaceAll(
      "{questionIdToMergeInto}",
      questionIdToMergeInto + ""
    );
    apiUrl = LinkHelpers.addQueryParam(apiUrl, {
      key: "questionIdToBeMerged",
      value: questionIdToBeMerged,
    });
    return new Api<void, void>(apiUrl, ApiMethod.PUT);
  }

  public static approve(id: number): Api<void, void> {
    return new Api(
      QuestionConstants.API_QUESTION_APPROVE.replaceAll(":questionId", "" + id),
      ApiMethod.POST
    );
  }

  public static disapprove(id: number): Api<void, void> {
    return new Api(
      QuestionConstants.API_QUESTION_DISAPPROVE.replaceAll(
        ":questionId",
        "" + id
      ),
      ApiMethod.POST
    );
  }

  public static archive(id: number): Api<void, void> {
    return new Api(
      QuestionConstants.API_QUESTION_ARCHIVE.replaceAll(":questionId", "" + id),
      ApiMethod.POST
    );
  }

  public static unarchive(id: number): Api<void, void> {
    return new Api(
      QuestionConstants.API_QUESTION_UNARCHIVE.replaceAll(
        ":questionId",
        "" + id
      ),
      ApiMethod.POST
    );
  }

  public static editQuestionWithAi(questionId: number): Api<void, Question> {
    const api = `/api/question/${questionId}/edit-with-ai`;
    return new Api<void, Question>(api, ApiMethod.POST);
  }

  public static addQuestionsWithAi(
    aiProviderType: string,
    modelName: string
  ): Api<{ rawContent: string }, Question[]> {
    let apiUrl = apiLinkConstants.API_QUESTION_CREATE_USING_AI;
    const params = new URLSearchParams();
    params.append("aiProviderType", aiProviderType);
    params.append("modelName", modelName);
    apiUrl = `${apiUrl}?${params.toString()}`;
    return new Api<{ rawContent: string }, Question[]>(apiUrl, ApiMethod.POST);
  }
}
